import { zodResolver } from "@hookform/resolvers/zod";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { z } from "zod";

// css
import styles from "../../../layout/Auth/Auth.module.scss";
import { loginAdmin } from "../../../store/actions";
import { useDispatch } from "react-redux";
import { useFirebase } from "../../../firebase/firebase";

const schema = z.object({
  email: z
    .string()
    .min(1, { message: "Email is required" })
    .email("Invalid email address"),
  password: z.string().min(1, { message: "Password is required" }),
});

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [viewPassword, setViewPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });
  const token = useFirebase();

  const firebasedata = token?.token;

  const submitHandler = async (data) => {
    const loginData = { ...data, firebaseToken: firebasedata };
    const callBack = (status) => {
      setTimeout(() => {
        navigate("/dashboard");
      }, 500);
    };
    dispatch(loginAdmin(loginData, callBack));
  };

  return (
    <>
      <div className="formInner px-lg-5 px-3 position-relative d-flex align-items-center justify-content-center flex-column h-100">
        <div className="w-100 inner">
          <div className="top py-2">
            <h4 className="m-0 fw-sbold">Log In</h4>
          </div>
          <Form
            className={`${styles.form}`}
            onSubmit={handleSubmit(submitHandler)}
          >
            <Row>
              <Col lg="12" className="my-2">
                <input
                  type="email"
                  className={`${styles.formControl} form-control bg-white`}
                  placeholder="Email Address"
                  {...register("email")}
                />

                {errors?.email && (
                  <p className="errorColor mb-0"> {errors.email.message} </p>
                )}
              </Col>
              <Col lg="12" className="my-2">
                <div className="iconWithText position-relative">
                  <input
                    type={viewPassword ? "text" : "password"}
                    className={`${styles.formControl} form-control bg-white`}
                    placeholder="Password"
                    {...register("password")}
                  />
                  <Button
                    className="icn position-absolute p-0 border-0"
                    variant="transparent"
                    type="button"
                    onClick={() => setViewPassword((p) => !p)}
                    style={{
                      right: 10,
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 25 17"
                      fill="none"
                    >
                      <path
                        d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                        fill="#666666"
                      />
                    </svg>
                  </Button>
                </div>

                {errors?.password && (
                  <p className="errorColor m-0">{errors.password.message}</p>
                )}
              </Col>
              <Col lg="12" className="my-1">
                <div className="d-flex gap-10 align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-10">
                    <input type="checkbox" className="form-check" />
                    <p className="m-0 fw-sbold">Remember me</p>
                  </div>
                  <Link
                    to="/forgot-password"
                    className={`${styles.link} fw-sbold`}
                  >
                    Forgot Password?
                  </Link>
                </div>
              </Col>
              <Col lg="8" className="my-2">
                <div className={`${styles.btnWrpper} btnWrpper`}>
                  <Button
                    className="d-flex align-items-center justify-content-center w-100 commonBtn"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};
export default Login;
